var _excluded = ["isValid", "disabled", "required", "value", "onChange", "onBlur", "onFocus", "name", "id", "label", "errorMessage", "description"];
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from 'react';
import PropTypes from 'prop-types';
import Box from '../box';
import Message from '../message';
import BaseCheckbox from './BaseCheckbox.js';
export default function Checkbox(_ref) {
  var _ref$isValid = _ref.isValid,
    isValid = _ref$isValid === void 0 ? true : _ref$isValid,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled,
    _ref$required = _ref.required,
    required = _ref$required === void 0 ? false : _ref$required,
    _ref$value = _ref.value,
    value = _ref$value === void 0 ? false : _ref$value,
    onChange = _ref.onChange,
    onBlur = _ref.onBlur,
    onFocus = _ref.onFocus,
    name = _ref.name,
    _ref$id = _ref.id,
    id = _ref$id === void 0 ? name : _ref$id,
    label = _ref.label,
    errorMessage = _ref.errorMessage,
    description = _ref.description,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(Box, {
    space: 1,
    "data-test": props['data-test']
  }, /*#__PURE__*/React.createElement(Box, {
    as: "label",
    htmlFor: id,
    extend: {
      cursor: disabled ? 'not-allowed' : 'pointer'
    }
  }, /*#__PURE__*/React.createElement(BaseCheckbox, {
    label: label,
    id: id,
    name: name,
    value: value,
    disabled: disabled,
    required: required,
    onChange: onChange,
    onBlur: onBlur,
    onFocus: onFocus,
    isValid: isValid
  })), errorMessage || description ? /*#__PURE__*/React.createElement(Box, {
    space: 0.5
  }, errorMessage && /*#__PURE__*/React.createElement(Message, {
    type: "error"
  }, errorMessage), description && /*#__PURE__*/React.createElement(Message, null, description)) : null);
}
Checkbox.propTypes = {
  /** The change event handler. */
  onChange: PropTypes.func.isRequired,
  /** A unique semantic name that is connected to the label. */
  name: PropTypes.string.isRequired,
  /** The controlled value. */
  value: PropTypes.bool,
  /** Sets the validation state. */
  isValid: PropTypes.bool,
  /** Sets disabled. */
  disabled: PropTypes.bool,
  /** Sets required. */
  required: PropTypes.bool,
  /** The label text. */
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  /** An error message text that is displayed once isValid is false. */
  errorMessage: PropTypes.string,
  /** Additional description information display beneath the input. */
  description: PropTypes.string
};